import * as types from '../mutation-types'
import { get_all_list_order, update_is_paid_order, move_table, split_person, pay_order, order_print_preview } from '@/api/order_list'
import Vue from 'vue'
import { update_order } from '@/api/item'

export const state = {
    loading: false,
    order_list: [],
    selected: null,
    void_status: false,
    meta: [],
    update_is_paid: false,
    input: {},
    loading_move_table: false,
    print_list: [],
    loading_print_list: false,
    filter_print_list: {},
    loading_update_order_split: false,
    cashier: {}
}

export const getters = {
    cashier: state => state.cashier,
    loading: state => state.loading,
    order_list: state => state.order_list,
    selected: state => state.selected,
    meta: state => state.meta,
    void_status: state => state.void_status,
    update_is_paid: state => state.update_is_paid,
    loading_move_table: state => state.loading_move_table,
    print_list: state => state.print_list,
    loading_print_list: state => state.loading_print_list,
    filter_print_list: state => state.filter_print_list,
    loading_update_order_split: state => state.loading_update_order_split,

}
export const mutations = {
    setFilterPrint(state, payload) {
        state.filter_print_list = payload
    },
    [types.MUTATION_UPDATE_LOCATION_ACTION](state, payload) {
        const item = state.order_list.find(item => item.id === payload.id)
        Object.assign(item, payload)
    },
    [types.FETCH_NEW_ORDER_ITEMS_SUCCESS](state, payload) {
        const item = state.order_list.find(item => item.id === payload.id)
        Object.assign(item, payload)
    },
    [types.UPDATE_IS_PAID_ORDER](state, payload) {
        state.update_is_paid = payload;
    },
    [types.UPDATE_IS_PAID_ORDER_SUCCESS](state, payload) {
        Vue.notify({
            group: 'notification',
            title: 'Completed',
            type: 'success',
            speed: 500,
            text: 'Your update order is paid Successful',
        });
        state.update_is_paid = payload;
    },
    [types.UPDATE_IS_PAID_ORDER_FAILD](state, payload) {
        state.update_is_paid = false;
    },
    [types.FETCH_ORDER_LIST](state, payload) {
        state.loading = true;
        state.order_list = payload;
    },
    [types.FETCH_VOID_ORDER_LIST](state, payload) {
        state.loading = false;
        state.void_status = payload;
    },
    [types.FETCH_PENDING_ORDER](state, payload) {
        state.loading = false;
        state.selected = payload;
    },
    [types.FETCH_ORDER_LIST_SUCCESS](state, payload) {
        state.loading = false;
        state.order_list = payload.items;
        state.meta = payload.meta
    },
    [types.FETCH_ORDER_LIST_FAILED](state, payload) {
        state.loading = false;
        state.order_list = [];
    },
    [types.MOVE_TABLE](state, payload) {
        state.loading_move_table = true;
    },
    [types.MOVE_TABLE_SUCCESS](state, payload) {
        state.loading_move_table = false;
    },
    [types.MOVE_TABLE_FAIL](state, payload) {
        state.loading_move_table = false;
    },
    getPrintList(state,) {
        state.loading_print_list = true
        state.print_list = [];
    },
    getPrintListDone(state, payload) {
        state.loading_print_list = false;
        state.print_list = payload.items
        state.cashier = payload.cashier
    },
    getPrintListFail(state,) {
        state.print_list = [];
        state.loading_print_list = false
    },

    updateSplitPersion(state) {
        state.loading_update_order_split = true
    },
    updateSplitPersionFail(state) {
        state.loading_update_order_split = false
    },

    updateSplitPersionDone(state) {
        state.loading_update_order_split = false
    }


}

export const actions = {

    async splitPerson({ commit }, payload) {
        commit('updateSplitPersion');
        try {
            const data = await split_person(payload);
            commit('updateSplitPersionDone', data);
        } catch (error) {
            commit('updateSplitPersionFail');
            throw error;
        }
    },

    async getPrintListPrintPreview({ commit, getters }) {
        commit('getPrintList');
        try {
            getters.filter_print_list.limit = 1000000;
            // const data = await get_all_list_order(getters.filter_print_list);
            const data = await order_print_preview(getters.filter_print_list);

            commit('getPrintListDone', data);
        } catch (error) {
            commit('getPrintListFail');
            throw error;
        }
    },

    async moveTable({ commit }, payload) {
        commit(types.MOVE_TABLE);
        try {
            let data = await move_table(payload);
            commit(types.MOVE_TABLE_SUCCESS, data.data);
        } catch (error) {
            commit(types.MOVE_TABLE_FAIL);
            throw error;
        }
    },
    async payOrder({ commit }, payload) {
        commit(types.UPDATE_IS_PAID_ORDER);
        try {
            const response = await pay_order(payload);
            commit(types.UPDATE_IS_PAID_ORDER_SUCCESS, response.data);
        } catch (error) {
            const err_ = error.response;
            commit(types.UPDATE_IS_PAID_ORDER_FAILD, err_)
        }
    },
    fetchSelectStatus({ commit }, payload) {
        commit(types.FETCH_PENDING_ORDER, payload)
    },
    async fetchOrderList({ commit, state }, payload) {
        commit(types.FETCH_ORDER_LIST)
        try {
            const data = await get_all_list_order(payload);
            commit(types.FETCH_ORDER_LIST_SUCCESS, data)

        } catch (error) {
            let error_ = error.response;
            commit(types.FETCH_ORDER_LIST_FAILED, error_)
        }
    },
    mutaionUpdateLocationAction({ commit }, payload) {
        commit(types.MUTATION_UPDATE_LOCATION_ACTION, payload)
    },
    mutaionUpdateNewOrdeListAction({ commit }, payload) {
        commit(types.FETCH_NEW_ORDER_ITEMS_SUCCESS, payload);
    }
}